import * as ArrayLabels from "bs-platform/lib/es6/arrayLabels.js";
var init = ArrayLabels.init;
var make_matrix = ArrayLabels.make_matrix;
var create_matrix = ArrayLabels.create_matrix;
var append = ArrayLabels.append;
var concat = ArrayLabels.concat;
var sub = ArrayLabels.sub;
var copy = ArrayLabels.copy;
var fill = ArrayLabels.fill;
var blit = ArrayLabels.blit;
var to_list = ArrayLabels.to_list;
var of_list = ArrayLabels.of_list;
var iter = ArrayLabels.iter;
var map = ArrayLabels.map;
var iteri = ArrayLabels.iteri;
var mapi = ArrayLabels.mapi;
var fold_left = ArrayLabels.fold_left;
var fold_right = ArrayLabels.fold_right;
var iter2 = ArrayLabels.iter2;
var map2 = ArrayLabels.map2;
var exists = ArrayLabels.exists;
var for_all = ArrayLabels.for_all;
var mem = ArrayLabels.mem;
var memq = ArrayLabels.memq;
var make_float = ArrayLabels.make_float;
var sort = ArrayLabels.sort;
var stable_sort = ArrayLabels.stable_sort;
var fast_sort = ArrayLabels.fast_sort;
var Floatarray = ArrayLabels.Floatarray;
export { init, make_matrix, create_matrix, append, concat, sub, copy, fill, blit, to_list, of_list, iter, map, iteri, mapi, fold_left, fold_right, iter2, map2, exists, for_all, mem, memq, make_float, sort, stable_sort, fast_sort, Floatarray };
/* No side effect */